var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 30,
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3345 2H5.68538C2.60872 2 0 4.53451 0 7.51026C0 10.486 2.60872 13 5.68538 13H24.3345C27.3913 13 30 10.4963 30 7.51026C30 4.52425 27.3913 2 24.3345 2ZM24.2549 11.7379H5.73516C3.29573 11.7379 1.28447 9.83955 1.28447 7.51026C1.28447 5.18097 3.29573 3.27239 5.73516 3.27239H24.2549C26.6844 3.27239 28.7056 5.17071 28.7056 7.51026C28.7056 9.84981 26.6944 11.7379 24.2549 11.7379Z",
    fill: "#CF043C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33529 4.66797H5.28418V10.3321H7.33529C8.06214 10.3321 8.73926 10.0346 9.25701 9.51125C9.77477 8.96741 10.0536 8.25939 10.0536 7.51032C10.0536 6.76125 9.76481 6.06349 9.25701 5.51965C8.73926 4.98607 8.06214 4.67823 7.33529 4.67823M7.25568 9.20342H6.41928V5.77618H7.25568C8.13188 5.7967 8.86868 6.55603 8.86868 7.50006C8.86868 8.44409 8.13188 9.1829 7.25568 9.20342Z",
    fill: "#CF043C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2073 4.69877C24.2073 4.69877 23.2017 6.53552 22.9328 7.04858C22.8532 6.89466 21.6384 4.65772 21.6384 4.65772H20.3042L20.344 4.75008C20.4237 4.88347 22.206 8.08496 22.3255 8.31071V10.3116H23.5402V8.31071C23.6397 8.11575 25.5415 4.64746 25.5415 4.64746H24.2272L24.2073 4.68851V4.69877Z",
    fill: "#CF043C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7822 10.3219H14.9442V9.20342H11.9373V8.07468H14.8048V6.95621H11.9373V5.77618H14.9442V4.66797H10.7822V10.3219Z",
    fill: "#CF043C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8525 10.3219H17.0175V8.07468H19.7755V6.95621H17.0175V5.77618H19.905V4.66797H15.8525V10.3219Z",
    fill: "#CF043C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefy);
export default __webpack_public_path__ + "static/media/defy.a5b47ffac8b3fe6bd553bf9bc40df526.svg";
export { ForwardRef as ReactComponent };